import Vue from "vue";
import Moment from "moment";
import VuemomentJS from "vue-momentjs";

const state = {
  categories: [],
  category: {},
  totalCategories: 0
};

const getters = {};

const actions = {
  LOAD_CATEGORY: function({ commit, rootState }, payload) {
    return Vue.prototype.$axios
      .get("/product_categories/" + payload.categoryId)
      .then(response => {
        commit("SET_CATEGORY", response.data.productCategory);
      });
  },
  LOAD_CATEGORIES: async function({ commit, rootState }, payload) {
    let idQuery = payload.id ? "&id=" + payload.id : "";
    let nameQuery = payload.name ? "&name=" + payload.name : "";

    return await Vue.prototype.$axios
      .get(
        "/product_categories?from=" +
          payload.from +
          "&limit=" +
          payload.to +
          idQuery +
          nameQuery
      )
      .then(response => {
        commit("SET_CATEGORIES", response.data.productCategories);
        commit("SET_TOTAL_CATEGORIES", response.data.meta.total);
        return response;
      });
  },
  LOAD_PRODUCTS({ commit }, payload) {
    return Vue.prototype.$axios
      .get(
        "product_categories/" +
          payload.categoryId +
          "/products?from=" +
          payload.from +
          "&limit=" +
          payload.to
      )
      .then(response => {
        commit("products/SET_PRODUCTS", response.data.products, { root: true });
        commit("products/SET_TOTAL_PRODUCTS", response.data.meta.total, {
          root: true
        });
      });
  },
  LOAD_SUBCATEGORIES: function({ commit, rootState, dispatch }, payload) {
    return Vue.prototype.$axios
      .get(
        "/product_categories/" +
          payload.categoryId +
          "/product_subcategories?from=" +
          payload.from +
          "&limit=" +
          payload.to
      )
      .then(response => {
        commit(
          "subcategories/SET_SUBCATEGORIES",
          response.data.productSubcategories,
          { root: true }
        );
        commit(
          "subcategories/SET_TOTAL_SUBCATEGORIES",
          response.data.meta.total,
          { root: true }
        );
        return response;
      });
  },
  UPDATE_CATEGORY: function({ commit, rootState, dispatch }, payload) {
    return Vue.prototype.$axios
      .post("/product_categories/" + payload.id, payload, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {});
  },
  CREATE_CATEGORY: async function({ commit, dispatch }, payload) {
    return await Vue.prototype.$axios
      .post("/product_categories", payload)
      .then(response => {});
  },
  DESTROY_CATEGORY: async function({ commit, dispatch }, payload) {
    return await Vue.prototype.$axios
      .delete("product_categories/" + payload)
      .then(response => {});
  }
};

const mutations = {
  SET_CATEGORIES: (state, categories) => {
    state.categories = categories;
  },
  SET_TOTAL_CATEGORIES: (state, totalCategories) => {
    state.totalCategories = totalCategories;
  },
  SET_CATEGORY: (state, category) => {
    state.category = category;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
